import { createContext, useContext } from 'react'
import { MAP_INSPECTOR_ACTION_TYPES } from './map-inspector-context-reducer'

export const MapInspectorContext = createContext(null)
export const MapInspectorContextDispatch = createContext(null)

export const useMapInspectorContext = () => {
  return useContext(MapInspectorContext)
}

export const useMapInspectorContextDispatch = () => {
  return useContext(MapInspectorContextDispatch)
}

// Dispatch Helpers

export const setSelectedCrop = ({ cropId, orgId }) => ({
  type: MAP_INSPECTOR_ACTION_TYPES.SET_SELECTED_CROP,
  cropId,
  orgId,
})

export const setHoveredCrop = ({ cropId }) => ({
  type: MAP_INSPECTOR_ACTION_TYPES.SET_HOVERED_CROP,
  cropId,
})

export const setPlotStatusMap = ({ plotStatusMap }) => ({
  type: MAP_INSPECTOR_ACTION_TYPES.SET_PLOT_STATUS_MAP,
  plotStatusMap,
})

export const setRelationshipCounts = ({ relationshipCounts }) => ({
  type: MAP_INSPECTOR_ACTION_TYPES.SET_RELATIONSHIP_COUNTS,
  relationshipCounts,
})
